<main class="main">
    <div class="main-wrapper">
        <section class="padding-first about1" id="about_us">
        <div class="container">

	        <a [routerLink]="['/news']" [routerLinkActive]="['active']" class="more">
	            <div class="icon-back">
	                <span>Back</span>
	            </div>
	        </a>


	        <div>
	          	<div class="bl-rows">
		            <div class="text">

                        <h2>Welcome, Luis!</h2>

                        <h2>We're thrilled to have you, the ultimate product hacker, as part of the Gennius team.</h2>

		                <span>By Gennius August 09, 2023</span>
		            </div>
		            <div class="img">
		                <img src="./assets/img/gennius/bg-inside-notice7.webp">
		            </div>
	          	</div>
	        </div>

	          	<div class="bl-center">

                    <p>He is now the driving force behind the awesome loyalty products and services we develop at <strong>gennius</strong>, working his magic by mixing together the latest technology, what customers really want, and the inspiration we all need to have, so that the company stays super innovative and customer-friendly in the world of finance, ecommerce and the ever-evolving Web3 ecosystems.</p>

		            <p>With over 30 years of experience in technology, operations, business development, and product management, Luis Eduardo has built an impressive career as a CTO working with multinational technology companies, financial services, and the travel industry. Having worked with prestigious clients like Compensar, Amadeus, Banco AvVillas or Experian, Luis Eduardo has significantly contributed to developing valuable partnerships to create cutting-edge technology-driven complementary products.</p>

                    <p>#Loyalty #ecommerce #payments</p>

                    <p><strong>New to Gennius? Let us introduce ourselves!</strong></p>

					<p>We proudly present ourselves as #miles, #MyRewards-VisaLoyaltySolution, #Novae, #CryptMi, and #MilesCare. Get ready for an exceptional journey! 🚀</p>

                    <p> <strong>*Who We Are*</strong> <br> We're not your ordinary Fintech company. Our obsession is creating extraordinary digital experiences that take engagement to new heights and nurture stronger loyalty among consumers.</p>

                    <p><strong>*How We Do It*</strong> <br> Our specialty lies in crafting tailored B2B2C super-app solutions that sport our clients' branding. These solutions resonate with a whopping 4 billion cardholders and over 420 million Web3 participants.</p>

                    <p><strong>*Who We Serve*</strong> <br> If you're a Financial Institution, Merchant, Crypto Exchange, or part of the Web3 community hungry for consumer loyalty and rewards, we're here for you. It's all about setting you apart with unique differentiators.</p>

                    <p> If you fall under the categories of #financialinstitution, #communitybank, #creditunion, #merchant, #web3community, or you're a membership-based consumer enterprise, Gennius XYZ has your back. We offer a #superapp (&web) that connects all your products into a single #branded (yes, yours) #digital #loyaltyrewards platform.</p>

                    <p>#loyalty #rewards #crypto #digital #Web3 #CYMi #digitalconsumer #seamless #convenient #personalized #engaging #superapp #microservices #relevant #whitelabel #travel #startup #fintech #venturecapital #scalable #miles #points #uppermiles #novae #cryptmi #utilitytoken #digital #currency #loyaltycoin #membership #cashless #redeem #perks #ewallet #blockchain #ethereum #p2p #AI #VisaDirect #cloud #BigData #mobilebanking #genXYZ</p>

	          	</div>

        </div>
      </section>


    </div>
</main>
<app-footer></app-footer>
